import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Hourglass, X } from "lucide-react";
import api from "../api";

const br = (d) => d.split("-").reverse().join("/");

export const WaitlistNotice = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/me/waitlist").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const leave = async (id) => { await api.delete(`/me/waitlist/${id}`); toast.success("Você saiu da lista de espera"); load(); };
  if (!items.length) return null;

  return (
    <div className="card-arya p-6 mb-6" data-testid="waitlist-notice">
      <div className="flex items-center gap-2 mb-3"><Hourglass size={16} className="text-[color:var(--sun-600)]"/><h3 className="font-serif text-xl">Lista de espera</h3></div>
      <ul className="space-y-2">
        {items.map(w => (
          <li key={w.wait_id} className={`flex flex-wrap items-center justify-between gap-3 rounded-xl px-4 py-3 ${w.vacancy ? "bg-[rgba(74,155,92,.15)]" : "bg-[var(--cream-100)]"}`} data-testid={`waitlist-${w.wait_id}`}>
            <span className="text-sm">
              {w.vacancy ? <b className="text-[#2F6B3C]">Abriu vaga em {br(w.date)}, agende agora!</b> : <>Aguardando vaga em <b>{br(w.date)}</b></>}
              <span className="text-[color:var(--ink-500)]"> · {w.service_title}</span>
            </span>
            <span className="flex items-center gap-2">
              {w.vacancy && <Link to={`/agendar?service=${w.service_id}&date=${w.date}`} className="btn-gold !py-1 !px-3 text-xs" data-testid={`waitlist-book-${w.wait_id}`}>Agendar</Link>}
              <button onClick={() => leave(w.wait_id)} className="p-1 text-[color:var(--ink-500)]" title="Sair da lista" data-testid={`waitlist-leave-${w.wait_id}`}><X size={14}/></button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
